import { create } from 'zustand';

type Filters = {
  name: string;
  phone_number: string;
};

type FiltersState = {
  filtersData: Filters;
  setFiltersData: (filters: Filters) => void;
  clearFilters: () => void;
};

const initalFilters: Filters = {
  name: '',
  phone_number: '',
};

export const useFilterAiUsersStore = create<FiltersState>((set) => ({
  filtersData: initalFilters,
  setFiltersData: (filters) => set({ filtersData: filters }),
  clearFilters: () => set({ filtersData: initalFilters }),
}));
